export default __webpack_public_path__ + "static/media/Logosvg-light.a1c4ce35.svg";